import Marquee from "react-fast-marquee";
import { FlameMark } from "@/components/Logo";
import { useLang } from "@/i18n/LanguageContext";

const ITEMS = ["marquee.parties", "marquee.clubs", "marquee.spanish", "marquee.english", "marquee.portuguese", "KNDLA"];

export default function MarqueeStrip() {
  const { t } = useLang();

  return (
    <div data-testid="marquee" className="overflow-hidden border-y border-white/10 bg-ash/40 py-6 md:py-8">
      <Marquee speed={32} gradient={false} pauseOnHover>
        {ITEMS.map((key, i) => (
          <span key={`${key}-${i}`} className="mx-8 flex items-center gap-16">
            {key === "KNDLA" ? (
              <img src="/kndla-tag-flame.png" alt="KNDLA" className="h-10 w-auto -rotate-2 md:h-14" />
            ) : (
              <span
                className={`font-syne text-4xl font-extrabold tracking-tight md:text-6xl ${
                  i % 2 === 0 ? "text-white" : "text-outline"
                }`}
              >
                {t(key)}
              </span>
            )}
            <FlameMark className="h-6 w-6 animate-flicker text-flame md:h-8 md:w-8" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
